import React, { useCallback, useMemo } from "react";
import { RefreshInterface } from "../../stores/interfaces/RefreshInterface";
import RefreshImage from "../../images/refresh-white.svg";
import ActionButton from "../declarants/groupButton";
import RefreshImageDisabled from "../../images/refresh-disabled.svg";

interface RefreshButtonProps {
  refresh: RefreshInterface;
  disabled?: boolean;
}

const RefreshButton: React.FC<RefreshButtonProps> = ({
  refresh,
  disabled = false,
}) => {
  const handler = useCallback(() => {
    refresh.refresh();
  }, [refresh]);

  const icon = useMemo(() => (disabled ? RefreshImageDisabled : RefreshImage), [
    disabled,
  ]);

  return (
    <ActionButton
      onClick={handler}
      disabled={disabled}
      icon={icon}
      style={{ height: "100%" }}
    />
  );
};

export default RefreshButton;
